import { axios } from "./axios";

export class Form {

    constructor(data = {}) {
        this.data = data;

        this.api_prefix = '/api';

        this.index_data = false;
        this.page = 1;

        this.filters = {};

        this.selected = false;
        this.type = false;

        this.form_updating = false;
        this.success = false;
        this.error = false
    }

    indexHasResults() {
        if (this.index_data && this.index_data.data) {
            return this.index_data.data.length > 0;
        }

        return false;
    }

    loadIndexData(endpoint, append = false, params = false) {
        let self = this;

        let uri = this.api_prefix + endpoint + '?page=' + self.page;

        if (params) {
            uri = uri + '&' + params;
        }

        return new Promise((resolve, reject) => {
            axios.get(uri)
                .then(response => {
                    self.processIndexData(response.data, append);

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    processIndexData(result, append = false) {
        let self = this;

        if (!self.index_data || append === false) {
            self.index_data = result;
        } else {
            self.index_data.data.push(...result.data)
        }
    }

    successful() {
        return this.success !== false;
    }

    getSuccessMessage() {
        return this.success;
    }

    setSuccessMessage(message, timeout = 4000) {
        let self = this;

        self.success = message;

        if (timeout) {
            setTimeout(function () {
                self.success = false;
            }, timeout);
        }
    }

    isFormUpdating() {
        return this.form_updating === true;
    }

    setFormUpdating() {
        this.form_updating = true;
    }

    setFormUpdateComplete() {
        this.form_updating = false;
    }

    resetFormMessages() {
        let self = this;

        return new Promise(resolve => {
            self.form_updating = false;
            self.success = false;
            self.error = false

            resolve(true);
        });
    }

    formatDate(date) {
        return window.moment(date).format('dddd, MMMM Do YYYY, h:mm:ss a');
    }

    formatDateHumanReadable(date) {
        return window.moment(date).from();
    }

    resetErrors() {
        this.error = false;
    }

    setError(error, isAxios = true) {
        if (isAxios) {
            this.error = error.response.data;
        } else {
            this.error = error;
        }

        this.setFormUpdateComplete();
    }

    getErrorMessage() {
        if (this.error.message) {
            return this.error.message;
        }

        return this.hasError() ? 'An unexpected error occurred, please contact support.' : null;
    }

    hasError() {
        return this.error !== false;
    }

    fieldHasErrors(field) {

        if (this.error && this.error.errors) {
            return this.error.errors.hasOwnProperty(field);
        }

        return false;
    }

    getFieldError(field) {
        if (this.fieldHasErrors(field)) {
            return this.error.errors[field][0];
        }

        return false;
    }

    /**
     * Get the use param from the response
     *
     * @param response
     * @return {boolean|Object}
     */
    responseUser(response) {

        if (response.data && response.data.user) {
            return response.data.user;
        }

        return false;
    }

    indexHasMoreResults() {
        if (this.index_data) {
            return this.index_data.meta && (this.page <= this.index_data.meta.last_page);
        }

        return false;
    }

    selectPreview(index, toggle = false) {
        let self = this;

        return new Promise(resolve => {
            if (toggle && self.selected === this.index_data.data[index]) {
                self.selected = false;
            } else {
                self.selected = this.index_data.data[index];
            }

            resolve(self.selected);
        });
    }

    sanitizeData(decimals = []) {
        let self = this;
        let data = {};

        for (const key in self.data) {
            if (decimals.includes(key)) {
                data[key] = this.convertDecimalToInteger(self.data[key]);
            } else {
                data[key] = self.data[key];
            }
        }

        return data;
    }

    convertDecimalToInteger(value) {
        return (value * 100);
    }

    indexDataAvailable() {
        if (this.index_data && this.index_data.data) {
            return this.index_data.data.length > 0;
        }

        return false;
    }

}
